import {NotificationWithID} from "@/types/notifications.type";

export const state = {
  listOfNotifications: [] as Array<NotificationWithID>,
};

export type State = typeof state;
